import React, { useEffect, useState } from "react";
import { SliderPanel } from "../../../../../components";
import { isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import PayrollTransactionDetails from "../FundingSliders/PayrollTransactionDetails";
import { getFundingDetailsByClassification } from "../../../../../services";
import PayrollFundingDetails from "../FundingSliders/PayrollFundingDetails";
import FundingDetailsCard from "../DisplayByPlan/FundingDetailsCard";
import PayrollFundingConfirmation from "../FundingSliders/PayrollFundingConfirmation";

const columns = [
  {
    label: "Plan Name",
    className: "column-plan-name",
  },
  {
    label: "Plan ID",
    className: "column-plan-id",
  },
  {
    label: "Employees",
    className: "column-employee",
  },
  {
    label: "Total funding",
    className: "column-total-funding",
  },
  {
    label: "Contribution details",
    className: "column-source-details",
  },
  {
    label: "Source Info",
    className: "column-fund-status",
  },
];

const DisplayFundingClassificationLevel = ({
  payrollId,
  classificationType,
  setViewByDisabled,
}) => {
  const [list, setList] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [planId, setPlanId] = useState();
  const [isFundModalOpen, setFundModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [classificationCodeId, setClassificationCodeId] = useState();
  const [toggle, setToggle] = useState(false);
  useEffect(() => {
    getFundingDetailsByClassification(payrollId, classificationType)
      .then((res) => {
        setList(res);
      })
      .catch((err) => {
        return err;
      });
  }, [payrollId, classificationType, toggle]);

  const showPopup = (id, code) => {
    setPlanId(id);
    setClassificationCodeId(code);
    setModalOpen(true);
  };

  const showFundPopup = (data, code) => {
    setData(data);
    setClassificationCodeId(code);
    setFundModalOpen(!isFundModalOpen);
  };

  return (
    <div className="payroll-columns">
      {!isEmpty(list) ? (
        <>
          <div className="d-flex justify-content-space-between align-items-center align-self-center">
            {columns.map((item, index) => {
              return (
                <p className={`ft-12 grey-text ${item.className}`}>
                  {item.label}
                </p>
              );
            })}
          </div>
          <>
            {list.map((division, index) => (
              <>
                <p className="d-flex align-items-center ft-14 black-text mb-10 line-header">
                  {division.classificationCode || "Others"}
                </p>
                <FundingDetailsCard
                  list={division.planDetailsForDivisions}
                  showPopup={showPopup}
                  showFundPopup={showFundPopup}
                  codeId={division.codeId}
                  isClassification={true}
                />
              </>
            ))}
          </>
        </>
      ) : (
        <div>No data</div>
      )}

      <SliderPanel
        isOpen={isModalOpen}
        size="30"
        showCancel={false}
        backdropClicked={() => setModalOpen(false)}
      >
        <div className="d-flex justify-content-between">
          <div className="ft-14 font-weight-500">Contribution details</div>
          <div>
            <FontAwesomeIcon
              icon={faTimes}
              size="18px"
              color="#828282"
              onClick={() => setModalOpen(false)}
              className="pointer"
            />
          </div>
        </div>
        <div className="border-top" />
        <PayrollTransactionDetails
          planId={planId}
          fileId={payrollId}
          classificationCodeId={classificationCodeId}
          setViewByDisabled={setViewByDisabled}
        />
      </SliderPanel>
      <SliderPanel
        isOpen={isFundModalOpen}
        size={data.fundingStatus && data.fundingStatus === 1 ? "85" : "50"}
        showCancel={false}
        // backdropClicked={() => setFundModalOpen(!isFundModalOpen)}
      >
        {data.fundingStatus && data.fundingStatus === 1 ? (
          <PayrollFundingDetails
            data={data}
            fileId={payrollId}
            toggle={toggle}
            setToggle={setToggle}
            classificationCodeId={classificationCodeId}
            classificationType={classificationType}
            isFundModalOpen={isFundModalOpen}
            setFundModalOpen={setFundModalOpen}
            setViewByDisabled={setViewByDisabled}
          />
        ) : (
          <PayrollFundingConfirmation
            data={data}
            toggle={toggle}
            fileId={payrollId}
            setToggle={setToggle}
            isClassification={true}
            classificationCodeId={classificationCodeId}
            classificationType={classificationType}
            isFundModalOpen={isFundModalOpen}
            setFundModalOpen={setFundModalOpen}
          />
        )}
      </SliderPanel>
    </div>
  );
};

export default DisplayFundingClassificationLevel;
